<template>
  <v-text-field v-bind="attributes"
                v-on="listeners"
                :value="value"
                :error="hasFieldErrors"
                @change="change"
                @focus="focused = true"
                @blur="focused = false"
                ref="proxy">
    <template slot="prepend-inner">
      <span class="text-minimum-gray">
        {{ prefix }}
      </span>
    </template>
    <template slot="append">
      <span class="text-minimum-gray">
        {{ suffix }}
      </span>
    </template>
  </v-text-field>
</template>

<script>
import InputMixin from '../mixins/input';
import _ from 'lodash';

const DEFAULTS = {
  clearable: false,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};

const PERCENT_REGEX = /(?<prefix>.*){N}(?<suffix>.*)/;

export default {
  mixins: [ InputMixin ],
  data () {
    return {
      focused: false
    };
  },
  computed: {
    attributes () {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);

      return result;
    },
    listeners () {
      return this.$listeners;
    },
    prefix () {
      let result = null;
      let format = this.$cove.getConfig('format.percent');
      let match = format.match(PERCENT_REGEX);
      let prefix = match.groups.prefix;
      if (!_.isEmpty(prefix))
      {
        result = this.trimToNull(prefix);
      }

      return result;
    },
    suffix () {
      let result = null;
      let format = this.$cove.getConfig('format.percent');
      let match = format.match(PERCENT_REGEX);
      let suffix = match.groups.suffix;
      if (!_.isEmpty(suffix))
      {
        result = this.trimToNull(suffix);
      }

      return result;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        if (!this.focused) {
          this.change(newValue);
        }
      }
    }
  },
  methods: {
    change (value) {
      let result = value;
      if (result === undefined || result === null)
      {
        result = null;
      }
      else
      {
        result = String(result);
        result = this.trimToNull(result);
        if (result !== null)
        {
          let parsed = this.$cove.parseNumber(result);
          if (parsed !== null)
          {
            result = this.$cove.formatDecimal(parsed);
          }
        }
      }

      if (result !== value)
      {
        this.$emit('input', result);
        this.$emit('change', result);
      }
    },
    getValueAsNumber () {
      return this.$cove.parseNumber(this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__prepend-inner,
::v-deep .v-input__append-inner {
  align-self: center;
  margin-top: 0;
}
</style>